import { useRootDispatch, useRootSelector } from "~redux/hooks";
import { closeView, gpdAselSelector, setAsel } from "~redux/slices/edstSlice";
import { ViewTitleBar } from "components/ViewTitleBar";
import type { HeaderComponentProps } from "components/utils/FullscreenView";

export const GpdHeader = ({ focused, toggleFullscreen, startDrag, width }: HeaderComponentProps) => {
  const dispatch = useRootDispatch();
  const asel = useRootSelector(gpdAselSelector);

  return (
    <ViewTitleBar
      width={width}
      focused={focused}
      toggleFullscreen={toggleFullscreen}
      startDrag={startDrag}
      closeView={() => {
        if (asel?.field?.endsWith("GPD_DB_FIELD")) {
          dispatch(setAsel(null));
        }
        dispatch(closeView("GPD"));
      }}
      text={["Graphic Plan Display - Current Time"]}
    />
  );
};
